import { FilterImportStatus } from '@/models/filters.model';
import { TFunction } from 'i18next';

export const getFilterImportStatusLabel = (t: TFunction, status?: FilterImportStatus) => {
  switch (status) {
    case FilterImportStatus.FINISHED:
      return t('imports_list_status_finished');
    case FilterImportStatus.PROCESSING:
      return t('imports_list_status_processing');
    case FilterImportStatus.FAILED:
      return t('imports_list_status_failed');
    default:
      return '';
  }
};
